<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <v-card-title primary-title> </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <label style="font-size: large"
                  >{{ $t("drivers.editConstraint.heading", { name: constraint.constraint_name }) }}</label
                >
                <v-text-field
                  outline
                  v-model="constraint.customer_app_message"
                  :label="$t('drivers.editConstraint.customerAppMessage')"
                  type="text"
                  :rules="[rules.required]"
                  style="margin-top: 15px"
                ></v-text-field>
                <v-flex xs12>
                  <v-select
                    :label="$t('drivers.editConstraint.canDriverEdit')"
                    :items="[
                      { text: $t('common.yes'), value: 1 },
                      { text: $t('common.no'), value: 0 },
                    ]"
                    v-model="constraint.driver_on_off"
                  ></v-select>
                </v-flex>

                <v-flex xs12>
                  <v-select
                    :label="$t('drivers.editConstraint.showInCustomerApp')"
                    :items="[
                      { text: $t('common.yes'), value: 1 },
                      { text: $t('common.no'), value: 0 },
                    ]"
                    v-model="constraint.customer_on_off"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :label="$t('drivers.editConstraint.showInCustomerDashboard')"
                    :items="[
                      { text: $t('common.yes'), value: 1 },
                      { text: $t('common.no'), value: 0 },
                    ]"
                    v-model="constraint.dashboard_on_off"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :label="$t('drivers.editConstraint.strikeThrough')"
                    :items="[
                      { text: $t('common.yes'), value: true },
                      { text: $t('common.no'), value: false },
                    ]"
                    v-model="constraint.strike_through"
                  ></v-select>
                </v-flex>
                <v-btn :loading="loading" block @click="save" color="secondary"
                  >{{ $t("drivers.editConstraint.save") }}
                </v-btn>
              </v-form>
            </v-flex>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "Edit_Constraint",
  title() {
    return this.$t("drivers.editConstraint.title");
  },
  components: {},

  data() {
    return {
      loading: false,
      form: false,
      isLoading: false,
      error: false,
      constraint: {
        constraint_name: "",
        customer_app_message: "",
        driver_on_off: false,
        customer_on_off: false,
        dashboard_on_off: false,
        strike_through: false
      },
    };
  },
  computed: {
    rules() {
      return {
        required: (v) => !!v || this.$t("common.required"),
      };
    },
  },
  watch: {},
  created() {
    this.axios
      .get(`dynamic_constraints/${this.$route.params.id}`)
      .then(({ data }) => {
        this.constraint.constraint_name = data.data.constraint_name;
        this.constraint.customer_app_message = data.data.customer_app_message;
        this.constraint.driver_on_off = data.data.driver_on_off;
        this.constraint.customer_on_off = data.data.customer_on_off;
        this.constraint.dashboard_on_off = data.data.dashboard_on_off;
        this.constraint.strike_through = data.data.strike_through;
      });
  },
  methods: {
    save() {
        if (!this.$refs.form.validate()) {
          window.getApp.$emit("SHOW_TOAST", this.$t("drivers.editConstraint.fillAllData"), "red");
          return;
        }
        this.loading = true;
        this.axios
          .put(`dynamic_constraints/${this.$route.params.id}`, {
            ...this.constraint,
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.editConstraint.constraintSaved"));
            this.$router.push(`/constraints`);
          })
          .catch(({ response }) => {
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.editConstraint.failedToSave"), "red");

            console.log(response);
          })
          .finally(() => (this.loading = false));
    },
  },
};
</script>
